import React from 'react'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'

import { useAppDispatch } from '../../../../../../App/Hooks/reduxHooks'
import { updateSurveyTrigger } from '../../../../Store/Action'
import style from '../../cardStyle.scss'
import { DescriptionCardState, TriggerFrequency } from '../EditDescriptionCard'
import { FrequencyDropDownLabel } from '../style'

type Props = {
  descriptionCardState: DescriptionCardState
  setDescriptionCardState: (arg: DescriptionCardState) => void
  surveyId: string
}

type DropDownData = {
  label: string
  value: TriggerFrequency
}

const dropDownData: DropDownData[] = [
  {
    label: 'After each appointment (until filled)',
    value: 'after_each_appointment',
  },
  {
    label: 'Only once',
    value: 'only_once',
  },
]

export const FrequencyDropDown: React.FC<Props> = ({
  descriptionCardState,
  setDescriptionCardState,
  surveyId,
}) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const trigger = descriptionCardState.trigger

  if (!trigger) {
    return null
  }

  return (
    <div style={{ margin: '18px 0' }}>
      <FrequencyDropDownLabel>
        {t('Select a frequency for this survey invitation')}
      </FrequencyDropDownLabel>
      <Select
        name="select-type"
        isClearable={false}
        defaultValue={
          trigger.frequency
            ? dropDownData.find(option => option.value === trigger.frequency)
            : dropDownData[0]
        }
        onChange={selectedValue => {
          // should be a TriggerFrequency because not clearable
          const frequency = selectedValue?.value as TriggerFrequency
          setDescriptionCardState({
            ...descriptionCardState,
            trigger: {
              ...trigger,
              frequency,
            },
          })
          dispatch(
            updateSurveyTrigger(surveyId, {
              ...trigger,
              frequency,
            }),
          )
        }}
        options={dropDownData}
        className={style.cardTypeSelection}
      />
    </div>
  )
}
